export const START_FETCH_TRANSACTIONS = 'START_FETCH_TRANSACTIONS';

export const SET_FETCHED_TRANSACTIONS = 'SET_FETCHED_TRANSACTIONS';

export const SET_FETCHED_DEFAULT_TRANSACTIONS = 'SET_FETCHED_DEFAULT_TRANSACTIONS';

export const START_FETCH_MORE_TRANSACTIONS = 'START_FETCH_MORE_TRANSACTIONS';

export const APPEND_FETCHED_TRANSACTIONS = 'APPEND_FETCHED_TRANSACTIONS';

export const FETCH_TRANSACTIONS_ERROR = 'FETCH_TRANSACTIONS_ERROR';

// Filters of Transaction Seaching
export const SET_FILTER = 'SET_FILTER';

export const UNSET_FILTER = 'UNSET_FILTER';

export const CHANGE_SORTING = 'CHANGE_SORTING';

export const RESET_FETCH_COUNT = 'RESET_FETCH_COUNT';

export const CLEAR_TRANSACTION_LIST = 'CLEAR_TRANSACTION_LIST';
